import { GraphicInfo, getSnapshotByGraphicInfo } from "@tuliu/base-map";
import env from "../../../src/config/env";

/**
 * 多图形生成截图
 * @param polygonList
 */
export const getPolygonImgBase64 = async (polygon: GraphicInfo[]) => {
  return getSnapshotByGraphicInfo({
    graphicInfoList: polygon,
    TianDiTuKey: env.TianDiTuKey,
    width: 420,
    height: 280,
    themeColor: "#0097ff",
  });
};
